import * as React from "react";
import {FC} from "react";
import {Box} from "@mui/material";
import {MailEditor} from "./MailEditor";
import {HTMLEditor} from "./HTMLEditor";
import {JSONEditor} from "./JSONEditor";
import {MailEditorEnum} from "../types/MailTypes";

interface MailEditorMainProps {
  index: number;
  selectedLanguage: string;
  mailType: string;
}

export const MailEditorMain: FC<MailEditorMainProps> = ({index, selectedLanguage, mailType}) => {
  const renderEditor = () => {
    if (mailType === "HTML") {
      return <HTMLEditor mailIndex={index} key={'html_' + selectedLanguage}/>
    } else if (mailType === "BRICK") {
      return <MailEditor index={index} key={'brick_' + selectedLanguage}/>
    } else if (mailType as any === MailEditorEnum.Json) {
      return <JSONEditor mailIndex={index} key={'json_' + selectedLanguage}/>
    } else {
      return <Box>Unknown editor {String(mailType)}</Box>
    }
  }

  return (
    <Box
      sx={{
        borderTop: '1px solid #e0e0e0',
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'center'
      }}>
      {renderEditor()}
    </Box>
  );
}